import React from 'react'
import PropTypes from 'prop-types'

const Locked = props => {
    return (
        <i class="fas fa-lock" onClick={e=>document.getElementById('Login_to_view_button').click()}></i>
    )
}


export default Locked
